import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { Input, Button, SuccessBlock, H2 } from 'components/Ui/index';

import { updateLoggedInUserDetails as updateLoggedInUserDetailsRequest } from 'containers/PrimoProfile/actions';
import { selectIsEditNameSuccessful } from '../selectors';
import styles from './styles.scss';
import commonStyles from '../styles.scss';

const EditAccountNameForm = ({
  onClose,
  defaultValues = {},
  updateLoggedInUserDetails,
  isEditNameSuccessful,
}) => {
  const [values, changeValues] = useState(defaultValues);

  const handleChange = ({ target: { value, name } }) => {
    changeValues({ ...values, [name]: value });
  };

  const handleSubmit = () => {
    updateLoggedInUserDetails(values);
  };

  const isSubmitDisabled =
    (defaultValues.firstName === values.firstName &&
      defaultValues.lastName === values.lastName) ||
    values.firstName.length === 0 ||
    values.lastName.length === 0;

  return (
    <Fragment>
      {!isEditNameSuccessful ? (
        <ValidatorForm onSubmit={handleSubmit}>
          <H2 className={commonStyles.header}>Edit name</H2>
          <div className={styles.inputFields}>
            <Input
              label="First Name:"
              name="firstName"
              id="firstName"
              ariaLabel="First Name"
              smallLabel
              value={values.firstName}
              onChange={handleChange}
              validators={['required']}
              errorMessages={['']}
            />
            <Input
              label="Last Name:"
              name="lastName"
              id="lastName"
              ariaLabel="Last Name"
              smallLabel
              value={values.lastName}
              onChange={handleChange}
              validators={['required']}
              errorMessages={['']}
            />
          </div>
          <Fragment>
            <div className={styles.formBottom}>
              <Button
                className={commonStyles.cancelButton}
                text="Cancel"
                type="button"
                onClick={onClose}
              />
              <Button
                className={commonStyles.button}
                text="Save"
                type="button"
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
              />
            </div>
          </Fragment>
        </ValidatorForm>
      ) : (
        <div className={styles.successContainer}>
          <SuccessBlock text="Your changes have been saved." />
        </div>
      )}
    </Fragment>
  );
};

EditAccountNameForm.propTypes = {
  updateLoggedInUserDetails: PropTypes.func.isRequired,
  isEditNameSuccessful: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  isEditNameSuccessful: selectIsEditNameSuccessful(),
});

const mapDispatchToProps = {
  updateLoggedInUserDetails: updateLoggedInUserDetailsRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditAccountNameForm);
